import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import PlansTab from '@/components/staff/PlansTab';
import ItemsTab from '@/components/staff/ItemsTab';
import DiscountCodesTab from '@/components/staff/DiscountCodesTab';

export default function Plans() {
  return (
    <div className="space-y-4">
      <h1 className="font-heading text-2xl font-700 text-charcoal">Plans &amp; Add-ons</h1>

      <Tabs defaultValue="plans">
        <TabsList data-testid="plans-items-tabs">
          <TabsTrigger value="plans" data-testid="plans-tab-trigger">Plans</TabsTrigger>
          <TabsTrigger value="items" data-testid="items-tab-trigger">Add-ons</TabsTrigger>
          <TabsTrigger value="discounts" data-testid="discounts-tab-trigger">Discount Codes</TabsTrigger>
        </TabsList>
        <TabsContent value="plans"><PlansTab /></TabsContent>
        <TabsContent value="items"><ItemsTab /></TabsContent>
        <TabsContent value="discounts"><DiscountCodesTab /></TabsContent>
      </Tabs>
    </div>
  );
}
